import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

export type FaqItem = {
  question: string;
  questionCn: string;
  answer: string;
  answerCn: string;
};

export const faqItems: FaqItem[] = [
  {
    question: "What CNC machines do you repair and service?",
    questionCn: "你们维修和保养哪些CNC机床？",
    answer:
      "We service multi-axis CNC mills, lathes, grinders, EDM machines (including wire cut), and vertical machining centres from most common brands. Send us your machine model and we will confirm whether we can help.",
    answerCn:
      "我们维修和保养多轴CNC铣床、车床、磨床、电火花机（包括线切割）和立式加工中心，涵盖大部分常见品牌。欢迎将您的机床型号发给我们，以便确认能否提供服务。",
  },
  {
    question: "Do you offer on-site CNC machine repair in the Klang Valley?",
    questionCn: "你们在巴生谷一带提供上门CNC维修服务吗？",
    answer:
      "Yes. We are based in Kota Kemuning, Shah Alam and regularly travel to workshops and factories around Shah Alam, Klang, Petaling Jaya, Kuala Lumpur, and the wider Klang Valley and Selangor area for on-site service work.",
    answerCn:
      "提供。我们位于雪兰莪莎阿南哥打哥文宁，经常前往莎阿南、巴生、八打灵再也、吉隆坡及巴生谷其他地区的工厂与车间提供上门维修服务。",
  },
  {
    question: "How fast can you respond to a CNC machine breakdown?",
    questionCn: "CNC机床故障后多快能得到回应？",
    answer:
      "Send us a WhatsApp message with your machine model, the alarm code or symptom, and a short photo or video if possible. We aim to reply on the same working day and arrange a visit based on the issue and our current schedule.",
    answerCn:
      "请通过WhatsApp发送机床型号、报警代码或故障现象，并尽可能附上照片或短视频。我们会尽量在同一个工作日内回复，并根据故障情况和当前排程安排上门服务。",
  },
  {
    question: "Do you handle CNC machine retrofitting and control upgrades?",
    questionCn: "你们处理CNC机床改造和控制系统升级吗？",
    answer:
      "Yes. We retrofit older CNC machines and grinders to extend their working life, covering control system, drives, spindle work, and calibration so the machine is reliable for daily production.",
    answerCn:
      "处理。我们为老旧CNC机床和磨床提供改造服务，包括控制系统、驱动器、主轴和精度校准，让机床能够稳定用于日常生产。",
  },
  {
    question: "Do you offer preventive maintenance contracts?",
    questionCn: "你们提供定期保养方案吗？",
    answer:
      "Yes. We can arrange scheduled inspection and preventive maintenance visits so small issues are caught early and your CNC machines stay stable in production. Tell us about your machines and how often you want them serviced and we will recommend a plan.",
    answerCn:
      "可以。我们可以安排定期巡检和预防性保养服务，及早发现小问题，让您的CNC机床在生产中保持稳定。请告诉我们您的机床情况和保养周期需求，我们会建议合适的方案。",
  },
  {
    question: "Where is Wii Seng Technology Resources located?",
    questionCn: "Wii Seng Technology Resources位于何处？",
    answer:
      "Our workshop is at 42, Jalan Sungai Merbau 32/89, Kota Kemuning, 40460 Shah Alam, Selangor, Malaysia. Phone and WhatsApp: +60 12 244 3138.",
    answerCn:
      "我们的工坊位于马来西亚雪兰莪莎阿南哥打哥文宁 42, Jalan Sungai Merbau 32/89，邮编40460。电话与WhatsApp：+60 12 244 3138。",
  },
];

const FaqSection = () => {
  return (
    <section id="faq" className="py-16 md:py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-wiiseng-gray max-w-2xl mx-auto">
            Common questions about CNC machine repair, maintenance, and
            retrofitting in Shah Alam and the Klang Valley.
          </p>
          <p
            className="text-lg text-wiiseng-gray max-w-2xl mx-auto"
            lang="zh"
          >
            关于莎阿南及巴生谷一带CNC机床维修、保养与改造服务的常见问题。
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="w-full">
            {faqItems.map((item, index) => (
              <AccordionItem key={index} value={`item-${index}`}>
                <AccordionTrigger className="text-left text-base md:text-lg font-semibold">
                  <span>
                    {item.question}
                    <span
                      className="block text-sm font-normal text-wiiseng-gray mt-1"
                      lang="zh"
                    >
                      {item.questionCn}
                    </span>
                  </span>
                </AccordionTrigger>
                <AccordionContent className="text-wiiseng-gray space-y-3 text-sm md:text-base">
                  <p>{item.answer}</p>
                  <p lang="zh">{item.answerCn}</p>
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FaqSection;
